import { useEffect, useState } from 'react'
import { PageHeader } from '@/components/layout/PageHeader'
import { useAppAuth } from '@/contexts/app-auth.context'
import { OrganizationSwitcher } from '@workos-inc/widgets'

export function OrganizationSwitcherPage() {
  const { getAccessToken } = useAppAuth()
  const [accessToken, setAccessToken] = useState<string | null>(null)

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken()
      setAccessToken(token)
    }
    fetchToken()
  }, [getAccessToken])

  return (
    <div className="space-y-6 p-6 pt-0">
      <PageHeader title="Switch between organizations or create new ones" />

      <div className="bg-card">
        {accessToken ? (
          <OrganizationSwitcher
            authToken={accessToken}
            switchToOrganization={() => {
              window.location.reload()
            }}
          />
        ) : (
          <div className="p-6">
            <div className="text-center">
              <p className="text-muted-foreground">Loading...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
